import { Start, Done } from '../actions/PageLoadingActions'

export const initialPageLoadingState = {
    isLoading: false,
}

export const PageLoadingReducer = (state = initialPageLoadingState, action) => {
    switch (action.type) {
        case Start:
            state.isLoading = true
            return state
        case Done:
            state.isLoading = false
            return state
        default:
            state = initialPageLoadingState
            return state
    }
}
